import apiPrd from '../../services/apiPrd'

const IncidentsService = {
  async fetchIncidentsByParams(params) {
    const res = await apiPrd.post('occurrence/search', params)
    return res.data
  },
  async fetchIncidentById(id) {
    const res = await apiPrd.get(`occurrence/${id}`)
    return res.data
  },
  async addEventToIncident(incidentId, payload) {
    const res = await apiPrd.post(`occurrence/${incidentId}/addEvent`, payload)
    return res.data
  },
  async closeIncident(id, payload) {
    const res = await apiPrd.post(`occurrence/${id}/close`, payload)
    return res.data
  },
  async getLoadsForIncidents() {
    const res = await apiPrd.get('shipping/occurrences')
    return res.data
  },
  async createIncident(payload) {
    const res = await apiPrd.post('occurrence/open', payload)
    return res.data
  },
  async forwardIncident(incidentId, payload) {
    const res = await apiPrd.post(`occurrence/${incidentId}/forward`, payload)
    return res.data
  },
}

export default IncidentsService
